import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    source: null
};

export const setGaSource = (state = INITIAL_STATE, { source }) => {
    return { ...state, source };
};

export const HANDLERS = {
    [Types.SET_GA_SOURCE]: setGaSource
};

export default createReducer(INITIAL_STATE, HANDLERS);
